import React from 'react'
import { Route, NavLink } from 'react-router-dom'

import { routes, useFlag } from '@sketch/modules-common'
import General from '../../pages/GeneralSettings'
import AppearanceSettings from '../../pages/AppearanceSettings'
import ManagePersonalTokensView from 'modules/personalTokens/views/ManagePersonalTokensView'
import { WorkspaceSidebarLayoutExtraProps } from 'modules/workspace/components/WorkspaceSidebarLayout/WorkspaceSidebarLayout'

import { PageWrapper } from './SettingsView.styles'

import { Segment, Navbar } from '@sketch/components'

const SettingsView = (props: WorkspaceSidebarLayoutExtraProps) => {
  const { workspace, NavbarPortal, useOverrideLayoutProps } = props

  useOverrideLayoutProps({
    title: 'Settings',
  })

  const isDarkModeToggleEnabled = useFlag('dark-mode-toggle')
  const personalTokenManagementEnabled = useFlag(
    'public-api-manage-personal-tokens'
  )

  const navbar = (
    <Navbar.Section ml={2}>
      <Segment
        type="text"
        label="General"
        render={(className, children) => (
          <NavLink
            exact
            className={className}
            to={routes.PERSONAL_SETTINGS.create({})}
          >
            {children}
          </NavLink>
        )}
      />
      {isDarkModeToggleEnabled && (
        <Segment
          type="text"
          label="Appearance"
          render={(className, children) => (
            <NavLink
              exact
              className={className}
              to={routes.APPEARANCE_SETTINGS.create({})}
            >
              {children}
            </NavLink>
          )}
        />
      )}
      {personalTokenManagementEnabled && (
        <Segment
          type="text"
          label="Access Tokens"
          render={(className, children) => (
            <NavLink
              exact
              className={className}
              to={routes.PERSONAL_SETTINGS_ACCESS_TOKENS.create({})}
            >
              {children}
            </NavLink>
          )}
        />
      )}
    </Navbar.Section>
  )

  return (
    <>
      <NavbarPortal>{navbar}</NavbarPortal>

      <PageWrapper>
        <Route
          exact
          path={[
            routes.PERSONAL_SETTINGS.template(),
            routes.PERSONAL_SETTINGS_UNSUBSCRIBE.template(),
          ]}
        >
          <General />
        </Route>
        <Route exact path={[routes.APPEARANCE_SETTINGS.template()]}>
          <AppearanceSettings />
        </Route>
        {personalTokenManagementEnabled && (
          <Route
            exact
            path={[
              routes.PERSONAL_SETTINGS_ACCESS_TOKENS.template(),
              routes.PERSONAL_SETTINGS_ACCESS_TOKENS_CREATE.template(),
            ]}
          >
            <ManagePersonalTokensView currentWorkspace={workspace} />
          </Route>
        )}
      </PageWrapper>
    </>
  )
}

export default SettingsView
